import { useEffect } from "react";

const useWrapperLock = (isOpen: boolean) => {
  useEffect(() => {
    const wrapper = document.getElementById("app-root");
    if (!wrapper) return;

    if (isOpen) {
      wrapper.style.overflow = "hidden";
      wrapper.style.height = "100dvh";
    } else {
      wrapper.style.overflow = "";
      wrapper.style.height = "";
    }
  }, [isOpen]);
};

export default useWrapperLock;
